import { DropdownOption } from "~/components/inputs/Dropdown";

// Valid incoterm values
export const INCOTERM_OPTIONS: readonly DropdownOption[] = [
  { value: "EXW", label: "EXW" },
  { value: "FCA", label: "FCA" },
  { value: "CIF", label: "CIF" },
  { value: "CFR", label: "CFR" },
  { value: "DAP", label: "DAP" },
  { value: "DDP", label: "DDP" },
  { value: "FOB", label: "FOB" },
] as const;
